// fr_pms_channel_manager.ts
// Tłumaczenia dla PMS.ChannelManager.tsx

export const frPmsChannelManager = {

  title: "Channel Manager",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    syncControl:  "Controle de synchronisation",
    connections:  "Connexions",
    recentSync:   "Dernieres tentatives de synchronisation",
    importLinks:  "Liens importes",
  },

  // ── Opisy ────────────────────────────────────────────────────────────────
  descriptions: {
    neutral:         "Distribution OTA sans lien fournisseur, import de reservations, protection du stock et suivi de synchronisation.",
    pushRates:       "Envoyer les tarifs et la disponibilite avec des cles de requete idempotentes.",
    providerStatus:  "Statut du fournisseur et visibilite des erreurs.",
    rateRows:        "Lignes de tarifs et de stock preparees pour la periode choisie.",
    syncHistory:     "Historique de synchronisation et erreurs sures pour les relances.",
    externalIds:     "Identifiants de canal externes lies aux reservations PMS.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    connection:         "Connexion",
    connections:        "Connexions",
    currentPushPayload: "Payload push actuel",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    importCompleted:"Import de reservation termine.",
    importFailed:   "Echec de l'import de reservation.",
    syncFailed:     "Echec de la synchronisation.",
  },

} as const;

export default frPmsChannelManager;
